import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { globalLetterAPIUrls } from '../data';
import {
  BrandingImages,
  DeleteBrandingResponse,
  FetchBrandingResponse,
  SaveBrandingResponse,
} from '../types';

export const saveBranding = withLogger(
  async (formData: FormData): Promise<BrandingImages> => {
    const url = globalLetterAPIUrls.branding.save;

    const response = await authServiceAxiosClient.post<SaveBrandingResponse>(
      url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    const responseData = response.data.data;
    const images = responseData.all_images || responseData;

    return {
      logo: images.logo || '',
      letterhead: images.letterhead || '',
      follower: images.follower || '',
    };
  },
);

export const fetchBranding = withLogger(async (): Promise<BrandingImages> => {
  const url = globalLetterAPIUrls.branding.fetch;

  const response = await authServiceAxiosClient.get<FetchBrandingResponse>(url);

  if (!response.data.success) {
    throw new Error(response.data.message);
  }

  const data = response.data.data;
  return {
    logo: data.logo || '',
    letterhead: data.letterhead || '',
    follower: data.follower || '',
  };
});

export const deleteBranding = withLogger(
  async (imageId: string, imageType: string): Promise<null> => {
    const url = globalLetterAPIUrls.branding.delete;

    const response =
      await authServiceAxiosClient.delete<DeleteBrandingResponse>(url, {
        data: { imageId, image_type: imageType },
      });

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data.data;
  },
);
